import { RoleInterface, APIScope, APIScopePermission } from '@swivl-mono/types';
import { Panel, Switch, Toggle } from '@swivl-mono/ui';
import RolesModel from '../../../../Models/Roles/Roles.Model';
import { useState } from 'react';
import { ActionAndName } from '../Role.Settings.Details.View';

interface PermissionsGroupSectionProps {
  heading: string;
  role: RoleInterface;
  actions: ActionAndName[];
  readOnly: boolean;
  isParentAndOwner?: boolean;
}

export function PermissionsGroupSection(props: PermissionsGroupSectionProps) {
  const { heading, role, actions, readOnly, isParentAndOwner } = props;
  const [isOpen, setIsOpen] = useState(false);

  const open = isOpen;
  const mergedActions = RolesModel.mergedActionsForRole(role);
  
  // const groupIsOn = Object.keys(mergedActions).every((action) => {
    
  //   return mergedActions[action as APIScope] === APIScopePermission.ALLOWED;
  // });
  let groupIsOn = true; 
  for (let action in role.actions) {
    if (!actions.find((a) => a.action === action)) {
      continue;
    }
    if (role.actions[action as APIScope] !== APIScopePermission.ALLOWED) {
      groupIsOn = false;
      break;
    }
  }

  return (
    <Panel
      open={open}
      header={heading}
      headerRight={
        <Switch
          readOnly={readOnly}
          on={groupIsOn}
          onChange={(e) => {
            let updatedRole = { ...role };
            

            for (let action in updatedRole.actions) {
              if (!actions.find((a) => a.action === action)) {
                continue;
              }
              if (isParentAndOwner) {
                updatedRole.actions[action as APIScope] = e.target.value
                  ? APIScopePermission.ALLOWED
                  : APIScopePermission.FORBIDDEN;


              } else {
              updatedRole.actions[action as APIScope] = e.target.value
                ? APIScopePermission.ALLOWED
                : APIScopePermission.INHERITED;
              }
            }
            

            RolesModel.updateRole(updatedRole);
          }}
        />
      }
      toggleOn={[Panel.ToggleOn.HEADER, Panel.ToggleOn.CHEVRON]}
      onToggle={() => {
        setIsOpen(!isOpen);
      }}
    >
      {actions.map((action) => {
        const selectedOption = role.actions[action.action]
          ? (role.actions[action.action] as string)
          : isParentAndOwner
          ? APIScopePermission.FORBIDDEN
          : APIScopePermission.INHERITED;
        return (
          <div
            key={action.action}
            className="text-sm flex items-center justify-between mb-3 pl-5"
          >
            {action.label}
            <Toggle
              readOnly={readOnly}
              options={
                isParentAndOwner
                  ? [
                      { value: APIScopePermission.ALLOWED, label: 'Allowed' },
                      {
                        value: APIScopePermission.FORBIDDEN,
                        label: 'Forbidden',
                      },
                    ]
                  : [
                      { value: APIScopePermission.ALLOWED, label: 'Allowed' },
                      {
                        value: APIScopePermission.FORBIDDEN,
                        label: 'Forbidden',
                      },
                      { value: APIScopePermission.INHERITED, label: 'Inherit' },
                    ]
              }
              selectedOption={selectedOption}
              onOptionSelected={(option) => {
                // update role
                // remove from role
                let updatedRole = { ...role };

                updatedRole.actions[action.action] =
                  option.value as APIScopePermission;

                RolesModel.updateRole(updatedRole);
              }}
            />
          </div>
        );
      })}
    </Panel>
  );
}
